import { ref, reactive, watch, onMounted } from '@vue/composition-api'
import { useRouter } from '@core/utils/utils'
// import store from '@/store'
// 接口地址
import {
  departTreeApi,
  departDeleteApi,
  departStatusApi,
  departSaveApi,
  departListApi,
} from '@/api/system/depart'
// 消息提醒
import MsgNotice from '@/comps/MsgNotice'
// 对话框提醒
import SweetAlert from '@/comps/SweetAlertModal'

export default function useFunction($can) {
  const { router } = useRouter()
  /* 页面文本信息 后期 多语言预留 */
  const moduleName = ref('depart')
  const moduleText = '组织'

  // 查询参数，自动生成界面
  const searchParamsBase = [
    // { param: 'name', component: 'input', type: 'text', label: '组织姓名', value: '', },
    // { param: 'phone', component: 'input', type: 'text', label: '手机号码', value: '', },
  ]
  /* 页面文本信息 后期 多语言预留 */

  // 左侧按钮配置
  const buttonLeftOptions = [
    // { label: '导入', variant: 'outline-primary', icon: 'UploadCloudIcon', event: 'upload' },
    // { label: '下载', variant: 'outline-primary', icon: 'DownloadCloudIcon', event: 'download' },
  ]
  // 右侧按钮配置
  const buttonRightOptions = [
    { label: '新建组织', variant: 'primary', icon: 'PlusIcon', event: 'add', rule: { action: 'add', subject: 'depart' } },
    // { label: '导入', variant: 'outline-primary', icon: 'UploadCloudIcon', event: 'upload' },
  ]

  // 表格操作菜单
  const menuData = [
    { clickType: 'edit', icon: 'EditIcon', text: '编辑', rule: { action: 'read', subject: 'Auth' } },
    { clickType: 'enable', icon: 'LockIcon', text: '启用', status: [false] },
    { clickType: 'disable', icon: 'UnlockIcon', text: '禁用', status: [true] },
    { clickType: 'delete', icon: 'Trash2Icon', text: '删除' },
  ]

  // 接口提示信息
  const MsgText = {
    // 获取数据
    fetchData: {
      success: { title: '', text: '' },
      fail: { title: `${moduleText}列表获取失败`, text: null }
    },
    // 状态管理
    statusEvent: {
      success: { title: `${moduleText}状态更新成功`, text: null },
      fail: { title: `${moduleText}状态更新失败`, text: null }
    },
    // 新增编辑
    editEvent: {
      success: { title: `${moduleText}编辑成功`, text: null },
      fail: { title: `${moduleText}编辑失败`, text: null }
    },
    // 删除操作
    deleteEvent: {
      success: { title: `${moduleText}删除成功`, text: null },
      fail: { title: `${moduleText}删除失败`, text: null },
      confirm: { title: `您确认需要删除此${moduleText}吗?`, text: '如果存在数据关联, 删除操作将会失败, 请知悉!' },
    },
  }

  // 状态参数
  const options = [
    { text: '启用', value: true, disabled: false },
    { text: '禁用', value: false, },
  ]

  // 状态参数
  const departOptions = [
    { text: '公司', value: 'company', disabled: false },
    { text: '部门', value: 'depart', },
  ]

  // 表单页面参数，自动生成界面
  const blankEditParams = reactive([
    { param: 'id', component: 'input', number: true, type: 'number', label: '组织ID', value: 0, display: true, },
    { param: 'name', component: 'input', type: 'text', label: '组织名称', value: '', rules: 'required', },
    { param: 'pid', component: 'select', label: '上级组织', value: 0, selectOptions: [], selectLabel: 'html' },
    { param: 'type', component: 'radio', label: '组织类型', radioOptions: departOptions, value: 'depart', rules: 'required', },

    { param: 'companyCode', component: 'input', type: 'text', label: '公司编码', value: '', rules: 'required', },
    { param: 'departCode', component: 'input', type: 'text', label: '部门编码', value: '', rules: 'required', },

    { param: 'sort', component: 'input', number: true, type: 'number', label: '排序', value: 0 },
    { param: 'status', component: 'radio', label: '状态', value: true, radioOptions: options, rules: 'required', },
  ])
  // 编辑或者新增对象
  const editValue = ref({})
  // 窗口控制
  const isShowSidebarActive = ref(false)

  /* 事件分发 */

  // 主控制按钮事件分发
  const mainActionEvent = type => {
    switch (type) {
      case 'add':
        blankEditParams.forEach(item => { editValue.value[item.param] = item.value })
        isShowSidebarActive.value = true
        break
      case 'upload': null
        break
      case 'download': null
        break
      default: null
    }
  }

  // 组件事件分发
  const searhPanelButtonEvent = clickButtonType => {
    switch (clickButtonType) {
      case 'search': searchFunction()
        break
      case 'more': null
        break
      case 'reset': resetFunction()
        break
      default: null
    }
  }

  // 表格事件分发
  const tableActionEvent = (type, extra) => {
    // router.push({ name: 'pages-knowledge-base-category', params: { category: item.category } })
    // router.push({ name: 'dashboard-ecommerce' })
    switch (type) {
      case 'edit':
        editValue.value = JSON.parse(JSON.stringify(extra))
        isShowSidebarActive.value = true
        break
      case 'enable': statusEvent({ id: extra.id })
        break
      case 'disable': statusEvent({ id: extra.id })
        break
      case 'delete': delEvent({ id: extra.id })
        break
      default: null
    }
  }

  /* 权限控制 */

  // 页面启动加载接口
  onMounted(() => { $can('all', 'manage') ? fetchData(searchParams) : MsgNotice('权限告警', '未获得组织树的权限') })

  /* 表格相关操作属性及数据 */

  // 适配表格
  const cellClassName = ({ column }) => {
    if (column.property === 'action' || column.property === 'pic') { return 'vxe-table-action-padding' }
  }

  // 查询参数
  const paramsBase = {}
  // 查询对象 添加自定义查询
  searchParamsBase.forEach(el => { paramsBase[el.param] = el.value })
  const searchParams = reactive(JSON.parse(JSON.stringify(paramsBase)))
  // 设置响应式查询组件参数变量
  const searchParamsObject = ref(JSON.parse(JSON.stringify(searchParamsBase)))

  // vxe-table 加载缓冲控制
  const loading = ref(false)
  // vxe-table 加载缓冲控制
  const xTable = ref(null)
  // 表格数据源
  const tableData = ref([])

  // 更改菜单的可用性 涉及权限，状态属性等
  const setMenuDisabled = (row, param) => {
    const menuInfo = JSON.parse(JSON.stringify(menuData))
    menuInfo.forEach(item => {
      // 判断是否被状态禁用
      const customerDisabled = item.status ? item.status.includes(row[param]) : false
      // 判断是否被权限禁用
      const rule = item.rule ? $can(item.rule.action, item.rule.subject) : true
      // 设置菜单的可用性
      item.disabled = customerDisabled && rule
      return item
    })
    return menuInfo.filter(item => !item.disabled)
  }

  /* 接口调用，抽离参数，函数等 */

  // 列表获取接口
  const fetchData = () => {
    departTreeApi(searchParams)
      .then(res => {
        tableData.value = res.data
      })
      .catch(err => { MsgNotice(MsgText.fetchData.fail.title, MsgText.fetchData.fail.text || err.msg) })
  }

  // 状态更新接口
  const statusEvent = id => {
    departStatusApi(id)
      .then(res => {
        fetchData()
        MsgNotice(
          MsgText.statusEvent.success.title,
          MsgText.statusEvent.success.text || res.msg,
          'CheckCircleIcon',
          'success',
        )
      })
      .catch(err => { MsgNotice(MsgText.statusEvent.fail.title, MsgText.statusEvent.fail.text || err.msg) })
  }

  // 新增或编辑接口
  const editEvent = val => {
    departSaveApi(val)
      .then(res => {
        fetchData()
        MsgNotice(
          MsgText.editEvent.success.title,
          MsgText.editEvent.success.text || res.msg,
          'CheckCircleIcon',
          'success',
        )
      })
      .catch(err => { MsgNotice(MsgText.editEvent.fail.title, MsgText.editEvent.fail.text || err.msg) })
  }

  // 删除接口
  const delEvent = id => {
    SweetAlert(MsgText.deleteEvent.confirm.title, MsgText.deleteEvent.confirm.text)
    .then(result => {
      if (result.value) {
        departDeleteApi(id)
          .then(res => {
            fetchData()
            MsgNotice(
              MsgText.deleteEvent.success.title,
              MsgText.deleteEvent.success.text || res.msg,
              'CheckCircleIcon',
              'success',
            )
          })
          .catch(err => { MsgNotice(MsgText.deleteEvent.fail.title, MsgText.deleteEvent.fail.text || err.msg) })
      }
    })
  }

  // 下拉查询分类
  const selectCateOne = () => {
    departListApi()
      .then(res => {
        blankEditParams.forEach(item => {
          if(item.param === 'pid') item.selectOptions = res.data
        })
    })
  }

  /* 页面生命周期管理，watch, onMounted, nextTick */

  // 处理参数查询
  // watch(searchParams, () => { fetchData(searchParams) })

  watch(isShowSidebarActive, val => { if (val) selectCateOne() })

  // 重置参数 操作处理
  const resetFunction = () => {
    searchParamsObject.value = JSON.parse(JSON.stringify(searchParamsBase))
  }
  // 查询组件 操作处理
  const searchFunction = () => {
    searchParamsObject.value.forEach(el => { searchParams[el.param] = el.value })
  }

  return {
    // 文本信息
    moduleName,
    moduleText,
    // 表格呈现
    cellClassName,
    loading,
    tableData,
    xTable,
    tableActionEvent,

    // 查询模块
    searchParams,
    searchParamsObject,
    
    // 接口函数
    fetchData,
    editEvent,
    delEvent,
    statusEvent,
    // 页面事件
    menuData,
    searhPanelButtonEvent,
    setMenuDisabled,
    // 主事件控制区
    buttonLeftOptions,
    buttonRightOptions,
    mainActionEvent,

    // 编辑对话框
    blankEditParams,
    editValue,
    isShowSidebarActive,
  }
}
